import { INTL_MARKETS, locales } from '@americanexpress/conditional-features';

const {
  EN_US,
  EN_GB,
  EN_AU,
  EN_NZ,
  EN_CA,
  FR_CA,
  ES_ES,
  EN_HK,
  IT_IT,
  JA_JP,
  ES_MX,
  NL_NL,
} = locales;

export const hasCountryOfResidenceDropdownRule = {
  devFlag: 'strategicInitiative',
  devLocales: [EN_GB],
  prodLocales: [],
};
export const hasCountryOfResidenceDropdownTooltipRule = {
  devFlag: 'strategicInitiative',
  devLocales: [EN_GB],
  prodLocales: [],
};
export const hasAirlineDropdownRule = [...INTL_MARKETS];
export const hasStrategicInitiativeRule = 'strategicInitiative';
export const hasFlightClassDropdownRule = [...INTL_MARKETS];
export const hasBundleTypeDropdownRule = [...INTL_MARKETS];
export const hasDisableNonStopRule = [
  EN_US,
  EN_GB,
  EN_AU,
  EN_NZ,
  EN_CA,
  FR_CA,
  ES_ES,
  EN_HK,
  IT_IT,
  JA_JP,
  ES_MX,
  NL_NL,
];

export const hasDisableRoomsTravelerModalRule = [EN_CA, FR_CA];
